import { IPromise, IQService, Injectable } from "angular";
import { ColDef } from "../../../records/grids/columns/colDef";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../records/grids/columns/columnDefinitionService";
import {
  ColumnDefinitionSetServiceProvider,
  vsProviderName as ColumnDefinitionServiceProviderName,
  vsServiceName as ColumnDefinitionSetServiceName,
  ColumnDefinitionSetService,
} from "../../../records/grids/columns/columnDefinitionSetService";
import {
  GridConfiguration,
  RecordGridViewServiceProvider,
  vsProviderName as RecordGridViewServiceProviderName,
} from "../../../records/views/recordGridView";
import {
  GridSettingsService,
  IGridSettings,
  vsName as GridSettingsServiceName,
} from "../../../records/grids/settings/gridSettingsService";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../records/server/serverUtility";
import { StateService } from "@uirouter/angularjs";

import { RecordDataSource } from "../../../records/grids";

import {
  machineObjectName,
  machineConfigurationObjectName,
} from "../../shared/names";
export { machineObjectName as vsObjectName } from "../../shared/names";

export function machineConfig(
  recordGridViewServiceProvider: RecordGridViewServiceProvider,
  columnDefinitionSetServiceProvider: ColumnDefinitionSetServiceProvider
) {
  recordGridViewServiceProvider.addGridConfiguration(machineObjectName, [
    "$q",
    ServerUtilityName,
    GridSettingsServiceName,
    "$state",
    ColumnDefinitionServiceName,
    "$compile",
    (
      $q: IQService,
      serverUtility: ServerUtility,
      gridSettingsService: GridSettingsService,
      $state: StateService
    ) =>
      new MachineGridConfiguration(
        $q,
        serverUtility,
        gridSettingsService,
        $state
      ),
  ]);

  columnDefinitionSetServiceProvider.addColumnDefinitionSet(machineObjectName, [
    ColumnDefinitionServiceName,
    ColumnDefinitionSetServiceName,
    (
      columnDefinitionService: ColumnDefinitionService,
      columnDefinitionSetService: ColumnDefinitionSetService
    ) => [
      columnDefinitionService.getNumberColDef({
        field: "Id",
        hide: true,
      }),
      columnDefinitionService.getNumberColDef({
        field: "MachineId",
        hide: true,
      }),
      columnDefinitionService.getNumberColDef({
        field: "MachineConfigurationId",
        hide: true,
      }),
      ...columnDefinitionSetService.getColumnDefinitionSet(
        machineConfigurationObjectName
      ),
    ],
  ]);
}
machineConfig.$inject = [
  RecordGridViewServiceProviderName,
  ColumnDefinitionServiceProviderName,
];

class MachineGridConfiguration implements GridConfiguration {
  columns?: ColDef[];
  columnDefinitionSet?: string = machineObjectName;
  onItemCommand?: Injectable<(...args: any[]) => IPromise<void>> = [
    () => {
      return this.$q.when();
    },
  ];
  gridDataSource?: RecordDataSource = new RecordDataSource(
    this.serverUtility,
    "/api/machines/Machine"
  );
  defaultSort?: string = "PropertyName,Status,Location,SlotNumber";
  nameSingular?: string = "Machine";
  namePlural?: string = "Machines";
  gridSelectionChanged?: Injectable<(...args: any[]) => void> = [
    () => {
      return this.$q.when();
    },
  ];
  gridSettings?: IGridSettings;
  showAddButton?: boolean = true;
  showAddButtonPermission?: string = "machineEdit";

  static $inject = ["$q", ServerUtilityName, GridSettingsServiceName, "$state"];
  constructor(
    private readonly $q: IQService,
    private readonly serverUtility: ServerUtility,
    gridSettingsService: GridSettingsService,
    private readonly $state: StateService
  ) {
    this.gridSettings = gridSettingsService.getGridSettings(
      Symbol("main.machines.grid")
    );
  }
}
